import type { RootStackParamList } from "../../../../navigation/types";
import type { NativeStackNavigationProp } from "@react-navigation/native-stack";

import { Button, Information } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

import { colors } from "@indeed/ifl-tokens/react-native";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  infoButton: {
    marginTop: -4,
    marginBottom: -4,
  },
});

export function JobDutiesDisclaimerPopover() {
  const gt = useI18n();
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  return (
    <Button
      variant="text"
      ariaLabel={gt.gettext("More information about AI-generated duties")}
      onPress={() => navigation.navigate("AIDisclaimerModal")}
      iconOnly={true}
      size="sm"
      sx={styles.infoButton}
      iconBefore={
        <Information size="xs" variant="stroke" color={colors.foregroundStrong} aria-hidden />
      }
    />
  );
}
